import React from 'react';
import './WhyusControl.css';

const WhyusControl = () => {
  return (
    <section className="whyuscontrol-section" id="control">
      <h2 className="whyuscontrol-heading">ENSURING YOU HAVE FULL CONTROL</h2>
      <p className="whyuscontrol-subheading">
        You can expect complete control and transparency when developing a project with Lattice Labs:
      </p>
      <div className="whyuscontrol-grid">
        <div className="whyuscontrol-item">
          <img src="/time.webp" alt="Time & Materials Basis" className="whyuscontrol-icon" />
          <h3>TIME & MATERIALS BASIS</h3>
          <p>
            We work on a Time & Materials basis, a fair and transparent process since you will pay only for the time allocated to your project. At the start of each project, we will provide you with a thorough project plan with an estimate so you have complete visibility of what to expect.
          </p>
        </div>
        <div className="whyuscontrol-item">
          <img src="/tof.webp" alt="Team of Experts" className="whyuscontrol-icon" />
          <h3>TEAM OF EXPERTS</h3>
          <p>
            We assign a team of experts to your project, which you can approve via CV and/or interview. Their day rate is dependent on their experience level. They are billed on a full day, and you will be invoiced monthly.
          </p>
        </div>
        <div className="whyuscontrol-item">
          <img src="/pm.webp" alt="Project Managers" className="whyuscontrol-icon" />
          <h3>PROJECT MANAGERS</h3>
          <p>
            We always recommend one of our project managers to be part of your project to ensure flawless implementation. It will ensure everything is on track, issues and deviations are raised in due time, and you can focus on your business.
          </p>
        </div>
        <div className="whyuscontrol-item">
          <img src="/meetings.webp" alt="Project Meetings" className="whyuscontrol-icon" />
          <h3>PROJECT MEETINGS</h3>
          <p>
            We have daily, weekly, and monthly project meetings to track its development, so you are always kept in the loop of its progress. In these sessions, we also identify in a transparent way any deviations from the initial plan.
          </p>
        </div>
        <div className="whyuscontrol-item">
          <img src="/control.webp" alt="Complete Control" className="whyuscontrol-icon" />
          <h3>COMPLETE CONTROL</h3>
          <p>
            You will have complete control of the project specifications and can change route whenever you feel like it. We will always provide you with a technical recommendation on the new route, as well as the estimated deviation from the initial project.
          </p>
        </div>
        <div className="whyuscontrol-item">
          <img src="/full.webp" alt="Full Ownership" className="whyuscontrol-icon" />
          <h3>FULL OWNERSHIP</h3>
          <p>
            You have full ownership of the source code created by our developers.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyusControl;
